



















































































import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';
import Vue from 'vue';
import { fetchSolicitudBaja } from '../fetchSolicitudBaja';
import { AxiosVue } from '@/AxiosVue'; //
import { LoadingService } from '@/services/loadingService';
import { ServicioProxy } from '@/config/enums'; //
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import Confirmation from '@/components/Confirmation.vue'; //
import { TranslateResult } from 'vue-i18n';
import { GridReadyEvent, GridApi } from 'ag-grid-community';
import DatosGenerales from './DatosGenerales.vue';
import DetalleClientes from './DetalleClientes.vue';

@Component({
  components: {
    DatePicker,
    'app-confirmacion': Confirmation,
    DatosGenerales,
    DetalleClientes,
  },
})
export default class EditarSolicitud extends Vue {
  @Prop({ required: true }) editedItem: any;
  @Prop({ required: true }) motivos: any;
  @Prop({ required: true }) clientes: any;
  ordesList: any;
  data: any = {};
  step = 'general';
  solicitudAnulada: boolean = false;

  modalGeneral: any;
  modalDetalles: any;
  mounted() {
    this.modalGeneral = this.$refs.datosGenerales;
    this.modalDetalles = this.$refs.datosDetallados;
  }

  async grabarEdicion() {
    if (this.modalDetalles.ordesList.length == 0) {
      this.$snotify.error('Por favor, cree al menos una solicitud', {
        timeout: 3000,
      });
      return;
    }
    let editarGeneral = await this.modalGeneral.editarDato();
    if (!editarGeneral) {
      return;
    }
    if (!this.datosActualizados) {
      this.closeModal(false);
      this.$snotify.success('Solicitud editada con exito', {
        timeout: 3000,
      });
      return;
    }
    let editardetalles = await this.modalDetalles.editarDato(
      this.modalGeneral.formFields.numero.value
    );

    if (editardetalles) {
      this.$snotify.success('Solicitud editada con exito', {
        timeout: 3000,
      });
      this.closeModal(false);
    }
  }

  cantEquipos: number = 0;
  cantPerifericos: number = 0;
  cantClientes: number = 0;
  datosActualizados: boolean = false;
  datostabla: any = [];

  actualizarInformacion(data: any) {
    this.datostabla = data;
    this.cantEquipos = data.reduce((acumulador: number, objeto: any) => {
      return acumulador + Number(objeto.equipos);
    }, 0);
    this.cantPerifericos = data.reduce((acumulador: number, objeto: any) => {
      return acumulador + Number(objeto.perifericos);
    }, 0);
    this.cantClientes = data.length;
    this.modalGeneral.actualizarCantidades(
      this.cantEquipos,
      this.cantPerifericos,
      this.cantClientes
    );
    this.datosActualizados = true;
    this.modalGeneral.validarDatos();
  }

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
  }

  onSelectionChanged(params: any) {}

  //abstract
  readonly funcionalidad: Funcionalidades =
    Funcionalidades.MovimientoDispositivos;

  //propiedades globales
  loadingService = new LoadingService();
  gridApi: GridApi;
  $snotify: any;
  dialog: boolean = true;
  dialogConfirmacionClose: boolean = false;
  validForm: boolean = false;
  dialogConfirmacion: boolean = false;
  btnBloquear: Boolean = false;

  //Interface
  estadoSwitch: boolean = false;

  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  //@Watch('show')
  async onPropertyChanged(value: boolean) {
    this.dialog = value;
    this.dialog = value;
    // permisos
    this.setBotonNav();
  }

  setBotonNav() {
    var accion = 'Editar';
    var evaluado = false;
  }

  cierraMenu() {
    var appBanners = document.getElementsByClassName(
      'ag-menu'
    ) as HTMLCollectionOf<HTMLElement>;
    if (appBanners.length > 0) {
      appBanners[0].remove();
    }
  }

  closeModal(val: boolean) {
    this.$validator.reset();
    document.getElementById('cardDivTV').scrollIntoView(true);
    this.$emit('modalAsociacionEmit', false);
    this.$emit('datoEditado', true);
    this.dialog = false;
    this.btnBloquear = false;
  }

  confirmCallback(val: any) {}

  confirmCallbackConfirm(val: boolean) {
    this.dialogConfirmacionClose = false;
    if (val) {
      this.closeModal(false);
    }
  }
}
